import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
    MatButtonModule, MatCheckboxModule, MatRadioModule, MatSelectModule,
    MatSlideToggleModule, MatDialogModule, MatTabsModule, MatMenuModule,
    MatTreeModule, MatIconModule, MatFormFieldModule, MatInputModule
} from '@angular/material';
import { AngularSplitModule } from 'angular-split';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { DbmComponentsModule } from './components/dbm-components/dbm-components.module';
import { DialogsModule } from './components/dialogs/dialogs.module';
import { IconLabelModule } from './components/icon-label/icon-label.module';
import { DynamicComponentModule } from './components/dynamic-component/dynamic-component.module';

import { DirectivesModule } from './directives/directives.module';
import { PipesModule } from './pipes/pipes.module';
import { BasicComponentsModule } from '@app/shared/components/basic-components/basic-components.module';

const materialModules = [
    MatButtonModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatTabsModule,
    MatMenuModule,
    MatTreeModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule
];

const modules = [
    CommonModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ScrollingModule,
    AngularSplitModule,
    ...materialModules,

    DbmComponentsModule,
    DialogsModule,
    IconLabelModule,
    DynamicComponentModule,   
    BasicComponentsModule,

    DirectivesModule,
    PipesModule
];

@NgModule({
    imports: [...modules],
    declarations: [],
    exports: [...modules]
})
export class SharedModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/shared.module.ts